import { axiosClient } from '../axios'

export const googleLogin = async (code) => {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  const result = await axiosClient.post('/auth/google_login', { code, timezone })

  return result
}
